import Vue from "vue";
import VueRouter from "vue-router";
import Contact from "./vue/contact.vue";

const appContact = "#app-contact";
if (document.querySelectorAll(appContact).length) {

    const router = new VueRouter({
        mode: "history"
    });
    Vue.use(VueRouter);

    var contactPageId = document.querySelector(appContact).dataset.contactpage;
    var contact = new Vue({
        el: appContact,
        data: {
            contactPageId: contactPageId
        },
        render: h => h(Contact),
        router
    });
}